import { useState, useEffect, useMemo } from 'react';
import { axiosInstance } from '../context/AuthContext';
import { ensureWindowCache } from '../utils/cache';
import { useCameraData } from '../hooks/useCameraData';
const TEN_MINUTES = 10 * 60 * 1000;

const buildProcessedData = (sessions) => {
  const emotionCounts = {
    positive: 0,
    neutral: 0,
    negative: 0
  };

  sessions.forEach((session) => {
    const emotion = (session.Emotion || session.emotion || '').toLowerCase();
    if (emotionCounts.hasOwnProperty(emotion)) {
      emotionCounts[emotion] += 1;
    }
  });

  const barChartData = Object.entries(emotionCounts).map(([emotion, count]) => ({
    emotion,
    count
  }));

  return {
    barChart: barChartData,
    pieChart: barChartData,
    radialChart: []
  };
};

export const useEmotionData = (artworkId, minDuration = 3.0) => {
  const { rawData, loading, error } = useCameraData(artworkId, 'emotion');    

  const processedData = useMemo(() => buildProcessedData(rawData), [rawData]);  

  return { processedData, rawData,loading, error };
};
